export * from './award-owned-statistics'
